import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {reactive} from 'vue';
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BookingMethod',
  props: ['modelValue', 'color', 'iconColor', 'isServiceMethodAvailable'],
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

const state = reactive({
  modelValue: props.modelValue,
  color: props.color,
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-4 border-rounded" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([state.modelValue.method == 'in_person' ? 'text-white' : '', "b-round-20"]),
                color: state.modelValue.method == 'in_person' ? state.color : '',
                disabled: !__props.isServiceMethodAvailable.in_person,
                variant: state.modelValue.method == 'in_person' ? 'flat' : 'text',
                onClick: _cache[0] || (_cache[0] = ($event: any) => {state.modelValue.method = 'in_person';emit('update:modelValue', state.modelValue)})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.dark && state.modelValue.method == 'in_person'  ? 'text-white' : '', "font-size-12-600 text-capitalize d-flex align-center ga-1"])
                  }, [
                    _cache[3] || (_cache[3] = _createTextVNode(" In person ", -1)),
                    _createVNode(Icon, {
                      color: state.modelValue.method == 'in_person'? 'white' : __props.iconColor,
                      icon: "location-icon"
                    }, null, 8, ["color"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["class", "color", "disabled", "variant"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([state.modelValue.method == 'video' ? 'text-white' : '', "b-round-20"]),
                color: state.modelValue.method == 'video' ? state.color : '',
                disabled: !__props.isServiceMethodAvailable.video,
                variant: state.modelValue.method == 'video' ? 'flat' : 'text',
                onClick: _cache[1] || (_cache[1] = ($event: any) => {state.modelValue.method = 'video';emit('update:modelValue', state.modelValue)})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.dark && state.modelValue.method == 'video'  ? 'text-white' : '', "font-size-12-600 text-capitalize d-flex align-center ga-1"])
                  }, [
                    _cache[4] || (_cache[4] = _createTextVNode(" Video ", -1)),
                    _createVNode(Icon, {
                      color: state.modelValue.method == 'video'? 'white' : __props.iconColor,
                      icon: "video-icon"
                    }, null, 8, ["color"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["class", "color", "disabled", "variant"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: _normalizeClass([state.modelValue.method == 'phone' ? 'text-white' : '', "b-round-20"]),
                color: state.modelValue.method == 'phone' ? state.color : '',
                disabled: !__props.isServiceMethodAvailable.phone,
                variant: state.modelValue.method == 'phone' ? 'flat' : 'text',
                onClick: _cache[2] || (_cache[2] = ($event: any) => {state.modelValue.method = 'phone';emit('update:modelValue', state.modelValue)})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.dark && state.modelValue.method == 'phone'  ? 'text-white' : '', "font-size-12-600 text-capitalize d-flex align-center ga-1"])
                  }, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Phone call ", -1)),
                    _createVNode(Icon, {
                      color: state.modelValue.method == 'phone'? 'white' : __props.iconColor,
                      icon: "phone-icon"
                    }, null, 8, ["color"])
                  ], 2)
                ]),
                _: 1
              }, 8, ["class", "color", "disabled", "variant"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})